
import { z } from "zod";

export const RequestForQuoteStatusValues = ["ACCEPTED", "AWAITING_READY_TO_ACCEPT", "PENDING_REVIEW", "REJECTED"] as const;
export const RequestForQuoteStatusSchema = /* @__PURE__ */ z.enum(RequestForQuoteStatusValues);
export const RequestForQuoteStatus: (typeof RequestForQuoteStatusSchema)["enum"] = { "ACCEPTED": "ACCEPTED", "AWAITING_READY_TO_ACCEPT": "AWAITING_READY_TO_ACCEPT", "PENDING_REVIEW": "PENDING_REVIEW", "REJECTED": "REJECTED" };
export type RequestForQuoteStatus = (typeof RequestForQuoteStatusValues)[number];
export const RequestForQuoteStatusDisplayNames = { "ACCEPTED": "Accepted",
"AWAITING_READY_TO_ACCEPT": "Awaiting Ready to Accept",
"PENDING_REVIEW": "Pending Review",
"REJECTED": "Rejected", } satisfies Record<RequestForQuoteStatus, string>;
